<template>
  <div id="inventory">
    <div v-for="(i, idx) in items" :key="idx">
      <div
        class="item"
        v-bind:class="{ active: i[1].inMantu }"
        @click="moveItem(i)"
      >
        {{ i[1].text }}
      </div>
    </div>
  </div>
</template>

<script>
import { setCondition } from "../mixins/setCondition.js";
import { mapGetters } from "vuex";
export default {
  name: "Inventory",
  components: {},
  mixins: [setCondition],
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "conditions",
      "selected",
      "itemsArray",
      "inventory",
      "inventoryPosition",
      // ...
    ]),
    items() {
      console.log(this.itemsArray);
      return this.itemsArray.filter((i) => i[1].inventory);
    },
  },
  methods: {
    moveItem(item) {
      item[1].inMantu
        ? this.$parent.removeItem(item[0])
        : this.$parent.takeItem(item[0]);
    },
    //remove (and move to store):
    takeItem(item) {
      if ("setCondition" in item) {
        if ("in" in item.setCondition) {
          this.setCondition(item.setCondition.in);
        }
      }
      this.$store.commit("increaseInventoryPosition");
      item.position = this.inventoryPosition;
      this.continue(item);
    },
    removeItem(item) {
      if ("setCondition" in item) {
        if ("out" in item.setCondition) {
          this.setCondition(item.setCondition.out);
        }
      }
      this.continue(item);
    },
    continue(item) {
      if ("isCondition" in item) {
        this.setCondition([[item.isCondition, !item.inMantu]]);
      } else {
        item.inMantu = !item.inMantu;
      }
    },
    //to here
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_variables.scss";

#inventory {
  margin-top: $margin-mid;
  color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
$box: $margin-small * 20;
.item {
  width: $box;
  height: $box;
  background: rgb(245, 131, 116);
  font-weight: bold;
  color: #353535;
  cursor: pointer;
  margin: $margin-small;
}
@import "../scss/_shared_private.scss";
</style>
